/**
 * Append Auth0's `ui_locales` parameter to a hosted-page URL so the page
 * renders in the deployment locale instead of the browser's Accept-Language.
 *
 * Auth0 password-change ticket URLs end with `#`; anything appended after it
 * would be treated as a fragment, so the hash is dropped before adding the
 * query parameter.
 */
export const appendUiLocales = (url: string, locale: string): string => {
  const parsed = new URL(url);
  parsed.hash = '';
  parsed.searchParams.set('ui_locales', locale);
  return parsed.toString();
};
